"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useSettableDictateAbortable;

var _useWebChatUIContext2 = _interopRequireDefault(require("./useWebChatUIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useSettableDictateAbortable() {
  var _useWebChatUIContext = (0, _useWebChatUIContext2.default)(),
      dictateAbortable = _useWebChatUIContext.dictateAbortable,
      setDictateAbortable = _useWebChatUIContext.setDictateAbortable;

  return [dictateAbortable, setDictateAbortable];
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9ob29rcy9pbnRlcm5hbC91c2VTZXR0YWJsZURpY3RhdGVBYm9ydGFibGUuanMiXSwibmFtZXMiOlsidXNlU2V0dGFibGVEaWN0YXRlQWJvcnRhYmxlIiwiZGljdGF0ZUFib3J0YWJsZSIsInNldERpY3RhdGVBYm9ydGFibGUiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTs7OztBQUVlLFNBQVNBLDJCQUFULEdBQXVDO0FBQ3BELDZCQUFrRCxvQ0FBbEQ7QUFBQSxNQUFRQyxnQkFBUix3QkFBUUEsZ0JBQVI7QUFBQSxNQUEwQkMsbUJBQTFCLHdCQUEwQkEsbUJBQTFCOztBQUVBLFNBQU8sQ0FBQ0QsZ0JBQUQsRUFBbUJDLG1CQUFuQixDQUFQO0FBQ0QiLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB1c2VXZWJDaGF0VUlDb250ZXh0IGZyb20gJy4vdXNlV2ViQ2hhdFVJQ29udGV4dCc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHVzZVNldHRhYmxlRGljdGF0ZUFib3J0YWJsZSgpIHtcbiAgY29uc3QgeyBkaWN0YXRlQWJvcnRhYmxlLCBzZXREaWN0YXRlQWJvcnRhYmxlIH0gPSB1c2VXZWJDaGF0VUlDb250ZXh0KCk7XG5cbiAgcmV0dXJuIFtkaWN0YXRlQWJvcnRhYmxlLCBzZXREaWN0YXRlQWJvcnRhYmxlXTtcbn1cbiJdfQ==